import React, { useEffect, useState } from 'react';
import Sidebar from 'pages/sideBar/SideBar';
import Skeleton from '@mui/material/Skeleton';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify'; // Added Toast
import 'react-toastify/dist/ReactToastify.css'; // Toast CSS
import './account.css';

function AccountPage() {
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [uploading, setUploading] = useState(false);
  
  // Separate visibility states for each password field
  const [showPrevPassword, setShowPrevPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    shopName: "",
    fullName: "",
    email: "",
    phone: "",
    companyName: "",
    location: "",
    vatNumber: "",
    business_license: "",
    position: "Manager",
    uploadDoc: null, 
    existingDocUrl: "", 
    bankName: "",
    accountHolder: "",
    accountNumber: "",
    iban: "",
  });

  const [tempData, setTempData] = useState(null);
  const [passwords, setPasswords] = useState({
    previousPassword: '',
    newPassword: '',
    rePassword: ''
  });

  const fetchData = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      setLoading(true);
      const response = await axios.get('https://production.washta.com/api/seller/Profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (response.data?.data) {
        const d = response.data.data;
        const b = d.business || {};
        const mappedData = {
          shopName: d.shopName || "",
          fullName: d.fullName || "",
          email: d.email || "",
          phone: d.phone || "",
          companyName: b.companyName || "",
          location: b.location || "",
          vatNumber: b.VATNumber || "",
          business_license: b.business_license || "",
          existingDocUrl: b.uploadDocument || "",
          position: b.position || "Manager",
          bankName: b.bank_name || "",
          accountHolder: b.account_holder_name || "",
          accountNumber: b.account_number || "",
          iban: b.iban || "",
          uploadDoc: null // Reset file selection on fetch
        };
        setUserData(mappedData);
      }
    } catch (err) {
      if (err.response?.status === 401) navigate('/');
      toast.error("Failed to load profile data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleEditToggle = () => {
    setTempData({ ...userData }); 
    setIsEditing(true);
  };

  const handleCancel = () => {
    setUserData(tempData); 
    setIsEditing(false);
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setUserData({ ...userData, uploadDoc: e.target.files[0] });
    }
  };

  const handleUpdateProfile = async () => {
    const token = localStorage.getItem('accessToken');
    let documentUrl = userData.existingDocUrl;

    try {
      setUploading(true);
      
      // 1. Handle File Upload if a new file is selected
      if (userData.uploadDoc) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', userData.uploadDoc);
        
        const uploadRes = await axios.post('https://production.washta.com/api/uploadFile', uploadFormData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
        // Assuming the API returns the path in this structure
        documentUrl = uploadRes.data.data.path; 
      }

      
    const payload = {
  username: userData.username, // add this if available
  shopName: userData.shopName,
  fullName: userData.fullName,
  phone: userData.phone,
  avatar: userData.avatar, // optional
  resizedAvatar: userData.resizedAvatar, // optional
  business: {
    companyName: userData.companyName,
    location: userData.location,
    VATNumber: userData.vatNumber,
    fullName: userData.fullName,
    position: userData.position,
    email: userData.email,
    uploadDocument: documentUrl,
    business_license: userData.business_license,
    bank_name: userData.bankName,
    account_holder_name: userData.accountHolder,
    account_number: userData.accountNumber,
    // name: userData?.accountName || userData.companyName
  }
};
console.log("Payload for update:", payload);
      await axios.patch('https://production.washta.com/api/seller/Profile', payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success("Profile Updated Successfully!");
      setIsEditing(false);
      fetchData(); // Refresh state with new data
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Update failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!passwords.previousPassword) return toast.warning("Enter previous password");
    if (!passwords.newPassword) return toast.warning("Enter new password");
    if (passwords.newPassword !== passwords.rePassword) return toast.error("Passwords do not match");

    const token = localStorage.getItem('accessToken');

    try {
      await axios.patch(
        'https://production.washta.com/api/seller/updatePassword',
        {
          previousPassword: passwords.previousPassword,
          newPassword: passwords.newPassword
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Password Updated Successfully!");
      setPasswords({ previousPassword: '', newPassword: '', rePassword: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to change password");
    }
  };

  const getInitials = (name) => {
    if (!name) return "NA";
    return name.split(" ").map(word => word[0]).join("").slice(0, 2).toUpperCase();
  };

  return (
    <div className='mainDiv-all-sideBar'>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className='div-sidebar'><Sidebar /></div>

      <div className='div-Dashbaord account-container'>
        <div className='account-header'>
          <h1 className='h1-all-heading'>Account Settings</h1>
          <div style={{ display: 'flex', gap: '10px' }}>
            {isEditing ? (
              <>
                <Button style={{fontSize: '14px', padding: '5px 20px',background: 'rgb(0 0 0 / 84%)', color: 'white'}} onClick={handleCancel}>Cancel</Button>
                <Button style={{fontSize: '14px', padding: '5px 20px',backgroundColor:'#6b5fe4'}} onClick={handleUpdateProfile} disabled={uploading}>
                  {uploading ? "Saving..." : "Save Changes"}
                </Button>
              </>
            ) : (
              <Button style={{fontSize: '14px', padding: '5px 20px',backgroundColor:'#6b5fe4'}} onClick={handleEditToggle}>Edit Profile</Button>
            )}
          </div>
        </div>

        {loading ? <Skeleton variant="rectangular" height={500} style={{ borderRadius: '15px' }} /> : (
          <div className="account-grid">
            
            {/* Identity & Company Details */}
            <div className='account-card full-width'>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}>
                
                {/* Identity Side */}
                <div style={{ flex: 1, minWidth: '300px' }}>
                  <h3 className='section-title'>IDENTITY</h3>
                  <div className='identity-header'>
                    <div className='avatar-circle'>
                      {getInitials(userData.companyName || userData.fullName)}
                    </div>
                    <div>
                      <h2 className='serif-font'>{userData.companyName || userData.fullName || "No Name"}</h2>
                      <p className='sub-text'>{userData.location || userData.position || "Service Provider"}</p>
                    </div>
                  </div>
                  <div className='info-row'>
                    <label>Shop name</label>
                    {isEditing ? <input className='edit-input' value={userData.shopName} onChange={(e)=>setUserData({...userData, shopName:e.target.value})} /> : <span>{userData.shopName}</span>}
                  </div>
                  <div className='info-row'>
                    <label>Full name</label>
                    {isEditing ? <input className='edit-input' value={userData.fullName} onChange={(e)=>setUserData({...userData, fullName:e.target.value})} /> : <span>{userData.fullName}</span>}
                  </div>
                  <div className='info-row'>
                    <label>Email</label>
                    <span>{userData.email}</span>
                  </div>
                  <div className='info-row'>
                    <label>Phone</label>
                    {isEditing ? <input className='edit-input' value={userData.phone} onChange={(e)=>setUserData({...userData, phone:e.target.value})} /> : <span>{userData.phone}</span>}
                  </div>
                  <div className='info-row'>
                     <label>Role</label>
                     <span className='status-badge active'>Active</span>
                   </div>
                </div>
 
                {/* Company Details Side */}
                <div style={{ flex: 1, minWidth: '300px' }}>
                  <h3 className='section-title'>COMPANY DETAILS</h3>
                  {/* <div className='info-row'>
                    <label>Company Name*</label>
                    <span>{userData.companyName}</span>
                  </div>
                  <div className='info-row'>
                    <label>Location*</label>
                      <span>{userData.location}</span>

                  </div> */}
                  <div className='info-row'>
                    <label>VAT Number*</label>
                    {/* {isEditing ? <input className='edit-input' value={userData.vatNumber} onChange={(e)=>setUserData({...userData, vatNumber:e.target.value})} /> : <span>{userData.vatNumber}</span>} */}
                    <span>{userData.vatNumber}</span>
                  </div>
                  <div className='info-row'>
                    <label>Business License*</label>
                    {isEditing ? (
                      <label className='file-upload-wrapper single-line'>
                        <span>
                          {userData.uploadDoc ? userData.uploadDoc.name : (userData.existingDocUrl ? userData.existingDocUrl.split('/').pop() : "Upload License")}
                        </span>
                        <input type="file" onChange={handleFileChange} hidden />
                      </label>
                    ) : (
                      <div className='file-display single-line'>
                        <span>{userData.existingDocUrl ? userData.existingDocUrl.split('/').pop() : "No File"}</span>
                        {userData.existingDocUrl && <a href={userData.existingDocUrl} target="_blank" rel="noreferrer" className='view-text'>View</a>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Bank Details */}
            <div className='account-card full-width'>
              <h3 className='section-title'>BANK DETAILS</h3>
              <div className='bank-grid'>
                <div className='input-box'><label>Bank Name*</label><input disabled value={userData.bankName} /></div>
                <div className='input-box'><label>Account Holder*</label><input disabled value={userData.accountHolder} /></div>
                <div className='input-box'><label>Account Number*</label><input disabled value={userData.accountNumber} /></div>
                <div className='input-box'><label>IBAN*</label><input disabled value={userData.iban} /></div>
              </div>
            </div>

            {/* Change Password */}
            <div className='account-card full-width'>
              <h3 className='section-title'>CHANGE PASSWORD</h3>
              <div className='bank-grid'>
                 <div className='input-box password-input-container'>
                  <label>Previous Password</label>
                  <input type={showPrevPassword ? "text" : "password"} value={passwords.previousPassword} onChange={(e)=>setPasswords({...passwords, previousPassword:e.target.value})} />
                  <span className='eye-icon' onClick={()=>setShowPrevPassword(!showPrevPassword)}>{showPrevPassword ? <FaEyeSlash /> : <FaEye />}</span>
                </div>
                <div className='input-box password-input-container'>
                  <label>New Password</label>
                  <input type={showNewPassword ? "text" : "password"} value={passwords.newPassword} onChange={(e)=>setPasswords({...passwords, newPassword:e.target.value})} />
                  <span className='eye-icon' onClick={()=>setShowNewPassword(!showNewPassword)}>{showNewPassword ? <FaEyeSlash /> : <FaEye />}</span>
                </div>
                <div className='input-box password-input-container'>
                  <label>Re-enter Password</label>
                  <input type={showRePassword ? "text" : "password"} value={passwords.rePassword} onChange={(e)=>setPasswords({...passwords, rePassword:e.target.value})} />
                  <span className='eye-icon' onClick={()=>setShowRePassword(!showRePassword)}>{showRePassword ? <FaEyeSlash /> : <FaEye />}</span>
                </div>
                <div className='input-box btn-container'>
                   <Button style={{fontSize: '14px', padding: '5px 20px',backgroundColor:'#6b5fe4'}} onClick={handleChangePassword} className="pass-btn">Update Password</Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AccountPage;